import React, { Component, Fragment } from 'react'
import { withRouteData, Head } from 'react-static'
import cx from 'classnames'

import Heading1 from '../../components/site/typography/Heading1'
import Heading5 from '../../components/site/typography/Heading5'
import Paragraph from '../../components/site/typography/Paragraph'
import RequestContact from '../../components/marketplace/Modal/RequestContactv2'
import NewMenu from '../../blocks/Menu/NewMenu'
import NewFooter from '../../blocks/NewFooter/Footer'

import './MarketplacePartnerv2.scss'

export default withRouteData(({ headData, company }) => (
    <Fragment>
        <Head>
            <title>{headData.pageTitle}</title>
            <meta property="og:title" content={headData.pageTitle} />
            <meta name="twitter:title" content={headData.pageTitle} />
            <meta name="description" content={headData.pageDescription} />
            <meta property="og:description" content={headData.pageDescription} />
            <meta name="twitter:description" content={headData.pageDescription} />
            <meta property="og:image" content={headData.ogImage} />
            <meta name="twitter:image" content={headData.ogImage} />
            <meta property="og:url" content={headData.ogUrl} />
            <link rel="canonical" href={headData.ogUrl} />
        </Head>
        <MarketplacePartner company={company} />
    </Fragment>
))

const PARTNERS_THAT_SET_UP_IN_MERCOS = []

class MarketplacePartner extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isSegmentsOpen: false,
            isServicesOpen: false,
        }
    }

    toggleList(label) {
        this.setState({
            [`is${label}Open`]: !this.state[`is${label}Open`]
        })
    }

    render() {
        var companyData = this.props.company.data,
            id = companyData.id,
            title = companyData.title,
            ranking = companyData.ranking,
            logo = companyData.logo,
            color = companyData.color,
            email = companyData.email,
            url = (companyData.url && companyData.url.indexOf('//') > -1 ? companyData.url : `http://${companyData.url}`) + '?utm_source=mercos&utm_medium=marketplace&utm_campaign=mercos-marketplace-indication',
            shortDescription = companyData.short_description,
            description = companyData.description,
            indication = companyData.indication,
            address = companyData.address,
            category = companyData.category,
            regions = companyData.regions,
            segments = companyData.segments,
            services = companyData.services,
            portifolioOwner = companyData.portifolio_owner,
            slug = companyData.slug

        return (
            <Fragment>
                <div className='new-partner-details-container'>
                    <NewMenu mutableMenu pixelsToShowMenuWhite={50} />
                    <div className="top-purple-bg">

                    </div>
                    <div className='partner-details-container'>
                        <div className='container'>
                            <div className="navigation-breadcrumbs">
                                <div className="breadcrumbs desktop-only">
                                    <a href="/integracao-erp" className='button-txt'>ERPs Integrados</a>
                                    <span className="navigation-breadcrumbs-separator">/</span>
                                    <span>{title}</span>
                                </div>
                                <a className="back-button" href="/integracao-erp">‹ voltar</a>
                            </div>
                            <div className='partner-head-container' {...(color && { style: { backgroundColor: color } })}>
                                <div className='partner-logo-container' style={{ backgroundImage: `url('${logo}')` }} />
                                <div className='cta-container'>
                                    <RequestContact
                                        className='btn-partner-contact'
                                        color={color}
                                        portifolioOwner={portifolioOwner}
                                        partnerEmail={email}
                                        partnerId={id}
                                        partnerName={title}>
                                        FALAR COM PARCEIRO
                                    </RequestContact>
                                    {PARTNERS_THAT_SET_UP_IN_MERCOS.includes(slug) &&
                                        <a
                                            className='new-button button-secondary-black'
                                            target='_blank'
                                            title='Configure no mercos'
                                            href={`https://app.mercos.com/nova_integracao/?erp=${slug}`}>
                                            CONFIGURAR NO MERCOS
                                        </a>
                                    }
                                    {url &&
                                        <a
                                            className='button-txt marketplace-partner-url'
                                            target='_blank'
                                            title='Configure no mercos'
                                            href={url}>
                                            site do parceiro ›
                                        </a>
                                    }
                                </div>
                            </div>
                            <div className='partner-content-container'>
                                <div className='content-container top-container'>
                                    <Heading1 className='partner-name'>{title}</Heading1>
                                </div>

                                <div className='left-container'>
                                    {description &&
                                        <div className='content-container title-container'>
                                            <Heading5>Descrição do negócio:</Heading5>
                                            <Paragraph>{description}</Paragraph>
                                        </div>
                                    }
                                    {segments &&
                                        <div className='content-container partner-segments-container'>
                                            <Heading5>Segmento que atende:</Heading5>
                                            {segments.map(function (segment, index) {
                                                var isHidden = !this.state.isSegmentsOpen && index > 4

                                                return <Paragraph className={cx('list-item', isHidden && 'hide')} key={`partner-segment-${index + 1}`}>{`• ${segment}`}</Paragraph>
                                            }, this)}
                                            {segments.length > 5 &&
                                                <Paragraph className={cx('toggle-button', this.state.isSegmentsOpen && 'open')} onClick={() => this.toggleList('Segments')}>{this.state.isSegmentsOpen ? 'Esconder' : 'Ver mais'}</Paragraph>
                                            }
                                        </div>
                                    }
                                    {services &&
                                        <div className='content-container partner-services-container'>
                                            <Heading5>Serviços:</Heading5>
                                            {services.map(function (service, index) {
                                                var isHidden = !this.state.isServicesOpen && index > 4

                                                return <Paragraph className={cx('list-item', isHidden && 'hide')} key={`partner-service-${index + 1}`}>{`• ${service}`}</Paragraph>
                                            }, this)}
                                            {services.length > 5 && <Paragraph className={cx('toggle-button', this.state.isServicesOpen && 'open')} onClick={() => this.toggleList('Services')}>{this.state.isServicesOpen ? 'Esconder' : 'Ver mais'}</Paragraph>}
                                        </div>
                                    }
                                    {indication &&
                                        <div className={cx('content-container partner-indication-container', color && 'custom-color')}>
                                            <Paragraph>{indication}</Paragraph>
                                            <div className='indication-background' style={{ 'backgroundColor': color }}></div>
                                        </div>
                                    }
                                </div>
                                <div className='right-container'>
                                    {category &&
                                        <div className='content-container category-container'>
                                            <Heading5>Categoria:</Heading5>
                                            <Paragraph>{category}</Paragraph>
                                        </div>
                                    }
                                    {regions &&
                                        <div className='content-container regions-container'>
                                            <Heading5>Região que atende:</Heading5>
                                            <Paragraph>{regions.join(', ')}</Paragraph>
                                        </div>
                                    }
                                    {address &&
                                        <div className='content-container address-container'>
                                            <Heading5>Sede da empresa:</Heading5>
                                            <Paragraph>{address}</Paragraph>
                                        </div>
                                    }
                                </div>

                            </div>
                        </div>
                    </div>
                    <NewFooter />
                </div>
            </Fragment>
        )
    }
}



// WEBPACK FOOTER //
// /usr/src/site-blog/src/containers/marketplace/MarketplacePartnerv2.jsx